export default "__VITE_ASSET__DQZH1_3G__"